import {CsvUploadedStatus} from "../csv-uploaded-status";
import {SortOrder} from "../sort-order";
import {CsvType} from "../csv-type";

export class CsvHistoryFilters {
  fileName: string;
  status: CsvUploadedStatus[];
  types: CsvType[];
  rangeDates: number[];
  sortField: string;
  sortOrder: SortOrder;
  tenantUuids: string[];
  organizationUuids: string[];
}
